<template>
  <AdminLayout>
    <AdminPreloader :loading="loading" message="Loading products..." />
    <div class="admin-products">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h2 class="section-title">
          <i class="fas fa-box"></i>
          Manage Products
        </h2>
        <router-link to="/admin/products/add" class="action-btn theme-btn">
          <i class="fas fa-plus"></i>
          Add New Product
        </router-link>
      </div>

      <div class="orders-table-container">
        <table class="modern-orders-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Price</th>
              <th>Category</th>
              <th>Stock</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in products" :key="product.id" class="order-row">
              <td class="order-id">#{{ product.id }}</td>
              <td class="product-name">{{ product.name }}</td>
              <td class="product-price">${{ product.price }}</td>
              <td>
                <span class="status-badge bg-info">
                  {{ product.category?.name || 'N/A' }}
                </span>
              </td>
              <td>
                <span class="status-badge" :class="product.stock > 0 ? 'bg-success' : 'bg-danger'">
                  {{ product.stock }} in stock
                </span>
              </td>
              <td>
                <AdminTableActions :item="product" @edit="editProduct" @delete="deleteProduct($event.id)" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </AdminLayout>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import AdminLayout from '../components/AdminLayout.vue'
import AdminPreloader from '../components/AdminPreloader.vue'
import AdminTableActions from '../components/AdminTableActions.vue'
import { useApiStore } from '../stores/api'

export default {
  name: 'AdminProducts',
  components: {
    AdminLayout,
    AdminPreloader,
    AdminTableActions
  },
  setup() {
    const router = useRouter()
    const products = ref([])
    const loading = ref(true)
    const apiStore = useApiStore()

    const fetchProducts = async () => {
      try {
        const response = await apiStore.get('/admin/products')
        console.log(response, 'response');
        products.value = response?.data?.data || []
      } catch (error) {
        console.error('Failed to fetch products:', error)
      } finally {
        loading.value = false
      }
    }

    const editProduct = (product) => {
      router.push(`/admin/products/add/${product.id}`)
    }

    const deleteProduct = async (id) => {
      if (confirm('Are you sure you want to delete this product?')) {
        try {
          await apiStore.delete(`/admin/products/${id}`)
          await fetchProducts()
        } catch (error) {
          console.error('Failed to delete product:', error)
        }
      }
    }

    onMounted(() => {
      fetchProducts()
      console.log('getting products', products.value)
    })

    return {
      loading,
      products,
      editProduct,
      deleteProduct
    }
  }
}
</script>

<style scoped>
.admin-products {
  padding: 20px 0;
}

.section-title {
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-title i {
  color: var(--theme, #6B8F71);
}

/* Modern Table Styles */
.orders-table-container {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.8);
  overflow: hidden;
}

.modern-orders-table {
  width: 100%;
  border-collapse: collapse;
}

.modern-orders-table thead th {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  color: #495057;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 20px 30px;
  text-align: left;
  border-bottom: 2px solid #dee2e6;
}

.modern-orders-table tbody tr {
  transition: all 0.3s ease;
  border-bottom: 1px solid #f1f3f4;
}

.modern-orders-table tbody tr:hover {
  background: linear-gradient(135deg, #f8f9fa, #f1f3f4);
}

.modern-orders-table tbody td {
  padding: 20px 30px;
  vertical-align: middle;
}

.order-id {
  font-weight: 600;
  color: var(--theme, #6B8F71);
}

.product-name {
  font-weight: 500;
  color: #2c3e50;
}

.product-price {
  font-weight: 600;
  color: #2c3e50;
}

.status-badge {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: inline-block;
  text-align: center;
  min-width: 100px;
}

.status-badge.bg-success {
  background: #e8f5e9;
  color: #2e7d32;
}

.status-badge.bg-danger {
  background: #ffebee;
  color: #c62828;
}

.status-badge.bg-info {
  background: #e1f5fe;
  color: #0277bd;
}

.action-btn {
  background: rgba(107, 143, 113, 0.1);
  color: var(--theme, #6B8F71);
  padding: 8px 16px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
}

.action-btn:hover {
  background: var(--theme, #6B8F71);
  color: white;
  transform: translateY(-1px);
}

.action-btn.theme-btn {
  background: var(--theme, #6B8F71);
  color: white;
}

.action-btn.theme-btn:hover {
  background: var(--header, #010F1C);
}
</style>
